import React, { useContext } from 'react';
import classNames from 'classnames';
import './trialButton.module.scss';
import { TrialLpContext } from '../../../contexts/trial';

type Props = {
    labelText?: any;
    children?: any;
    styleName?: string;
    className?: string;
    bodyClassName?: string;
    onClick?: () => any;
};

export const TrialButton = ({ labelText, children, className, bodyClassName, onClick }: Props) => {
    const { reservationPagePath } = useContext(TrialLpContext);
    return (
        <a
            styleName={classNames('trial-button', { 'with-label': !!labelText })}
            className={className}
            href={reservationPagePath}
            target="_blank"
            onClick={onClick}
        >
            <div styleName="body" className={bodyClassName}>
                {labelText && <div styleName="label">{labelText}</div>}
                {children}
            </div>
            <div styleName="arrow" />
        </a>
    );
};

export const NavigationTrialButton = ({ children, className, onClick }: Props) => {
    const { reservationPagePath } = useContext(TrialLpContext);
    return (
        <a
            styleName={classNames('navigation-trial-button')}
            className={className}
            href={reservationPagePath}
            target="_blank"
            onClick={onClick}
        >
            <div styleName="navigation-body">{children}</div>
        </a>
    );
};
